// API Keys for Alpha Vantage
export const apiKeys = [
  "UY4D3515274IRE6J" // 替换为您的Alpha Vantage API密钥
];

// Function to get a random API key from the pool
export const getRandomApiKey = () => {
  const randomIndex = Math.floor(Math.random() * apiKeys.length);
  return apiKeys[randomIndex];
}; 